import {Scene} from 'scene';
import {Animation} from 'animation';
import UiScene from './uiscene';
import UiSettings from "./uisettings";
import UiHelp from "./uihelp";
import Cards from "./cards";
import {GAME_INFO as GI} from './common/game'
import {goLobby} from 'minigame_client/minigame_client'
import {round_price, literal_price_with_check_zero_fractional_part} from './common/ui';
import AccountChangedWindow from "./account_changed_window";

import SETTINGS from 'settings'

const GDealerMaxPointsForStopTake = 17;         // При набранных очках < 17 дилер должен взять карту
const GMaxCountCards = 5;                       // Максимальное количество карт на руках - 5

// сохраняем состояние между реинициализациями при повороте экрана
let GlobalSavedGameState = {
    scoreWin: 0,
    scoreForward: 0,
    scoreLose: 0,
    isFirstRun: true,
    isFirstPlaceBet: true,
    isNeedShowResult: false,
    isAutoEnable: false,
    isSoundEnable: false,
};

export default class MainScene extends Scene
{
    constructor(space, configGame, configMenu, configPanel) {

        super();

        let self = this;

        this.space = space;

        const packFolder = configGame.packFolder;
        const pathRes = "res/" + configGame.pathFolder;
        const screen = configGame.Screen;
        this.isDesktopHorizontal = configGame.type === "DesktopHorizontal";

        const config = configGame.MainScene;


        if (!this.isDesktopHorizontal) {
            let htmlElement = window.document.documentElement;
            htmlElement.style.backgroundImage = 'url(' + pathRes + "adaptiveBackground.jpg" + ')';
        }


        this.sndForward = sounds.get("res/sounds/forward");
        this.sndLose = sounds.get("res/sounds/lose");
        this.sndWin = sounds.get("res/sounds/win");

        this.maingameBackground = new PIXI.Sprite(PIXI.utils.TextureCache[pathRes + config.maingameBackground.name]);
        this.addChild(this.maingameBackground);


        this.ui = new UiScene(configGame, configMenu, configPanel);
        this.addChild(this.ui);

        this.uiBorder = new PIXI.Sprite(PIXI.utils.TextureCache[packFolder + "border.png"]);
        this.uiBorder.position.set(config.uiBorder.pos.x, config.uiBorder.pos.y);
        this.addChild(this.uiBorder);

        this.ui.setOnButtonMoreEvent(this.onButtonMore.bind(this));
        this.ui.setOnButtonStopEvent(this.onButtonStop.bind(this));
        this.ui.setOnButtonPlaceBetEvent(this.onButtonPlaceBet.bind(this));
        this.ui.setOnButtonExitEvent(this.onButtonExit.bind(this));

        this.ui.setOnButtonSoundOnEvent(() => {GlobalSavedGameState.isSoundEnable = false;});
        this.ui.setOnButtonSoundOffEvent(() => {GlobalSavedGameState.isSoundEnable = true;});

        this.cards = new Cards(configGame, this.onGetCard.bind(this), this.onDataReady.bind(this));
        this.addChild(this.cards);


        this.resultWin = new PIXI.Sprite(PIXI.utils.TextureCache[pathRes + "tables/win.png"]);
        this.resultWin.position.set(config.resultWin.pos.x, config.resultWin.pos.y);
        this.resultWin.visible = false;
        this.addChild(this.resultWin);

        this.resultForward = new PIXI.Sprite(PIXI.utils.TextureCache[pathRes + "tables/forward.png"]);
        this.resultForward.position.set(config.resultForward.pos.x, config.resultForward.pos.y);
        this.resultForward.visible = false;
        this.addChild(this.resultForward);

        this.resultLose = new PIXI.Sprite(PIXI.utils.TextureCache[pathRes + "tables/lose.png"]);
        this.resultLose.position.set(config.resultLose.pos.x, config.resultLose.pos.y);
        this.resultLose.visible = false;
        this.addChild(this.resultLose);


        this.help = new UiHelp(configGame);
        this.help.visible = false;
        this.addChild(this.help);

        this.ui.setOnButtonHelpEvent(this.onButtonHelp.bind(this));
        this.help.setOnButtonCloseEvent(this.onButtonHelp.bind(this));


        this.settings = new UiSettings(configGame);
        this.settings.visible = false;
        this.settings.setActiveDeck(0);
        this.addChild(this.settings);

        this.ui.setOnButtonSettingsEvent(this.onButtonSkin.bind(this));
        this.settings.setOnButtonApplyEvent(this.onButtonSkinApply.bind(this));

        this.ui.setOnButtonAutoPlayOnEvent(this.onButtonAutoOn.bind(this));
        this.ui.setOnButtonAutoPlayOffEvent(this.onButtonAutoOff.bind(this));
        this.isAutoPlay = false;

        this.accountChangedWindow = new AccountChangedWindow(configGame);
        this.addChild(this.accountChangedWindow);

        // this.layerBlockInput = new PIXI.Sprite(new PIXI.Texture(PIXI.Texture.EMPTY, new PIXI.Rectangle(0, 0, screen.resolution.width, screen.resolution.height)));
        this.layerBlockInput = new PIXI.Sprite(PIXI.Texture.WHITE);
        this.layerBlockInput.position.set(0, 0);
        this.layerBlockInput.interactive = true;     // block interactive of overlaid buttons
        this.layerBlockInput.visible = false;
        this.layerBlockInput.width = screen.resolution.width;
        this.layerBlockInput.height = screen.resolution.height;
        this.layerBlockInput.tint = 0x000000;
        this.layerBlockInput.alpha = 0.7;
        this.addChild(this.layerBlockInput);

        this.layerOverBlockInput = new PIXI.Container();
        this.addChild(this.layerOverBlockInput);


        // проверка - есть ли сеть после реинициализации
        space.s('checkError')
            .with(space.s('isError'),(_, arg2) => ({arg2}))
            .on(({arg2}) => {
                if (arg2) {
                    self.layerBlockInput.visible = true;
                    self.ui.addLobbyButtonToNewParrent(self.layerOverBlockInput);
                }
                else {
                    self.layerBlockInput.visible = false;
                    self.ui.resetLobbyButtonParrent();
                }
            });
        space.s('isError').to(space.s('checkError'));
        space.s('checkError').next();


        if (SETTINGS.ROOT_CONTAINERS.ui_adaptive_container && !this.isDesktopHorizontal) {
            this.removeChild(this.help);
            this.removeChild(this.settings);
            this.removeChild(this.accountChangedWindow);
            this.removeChild(this.layerBlockInput);

            SETTINGS.ROOT_CONTAINERS.ui_adaptive_container.addChild(this.help);
            SETTINGS.ROOT_CONTAINERS.ui_adaptive_container.addChild(this.settings);
            SETTINGS.ROOT_CONTAINERS.ui_adaptive_container.addChild(this.accountChangedWindow);
            SETTINGS.ROOT_CONTAINERS.ui_adaptive_container.addChild(this.layerBlockInput);
        }


        this.credits = 0;
        this.totalBetMin = 0;
        this.totalBetMax = 100000;
        this.currencyPrecision = 0;
        this.currencyDelimiter = '.';
        this.currencyBet = 'RUB';
        this.currencyCredits = 'RUB';
        this.precisionCeil = 0;

        this.lastBet = 0;
        this.lastBetCurrency = 'RUB';

        this.scoreWin = GlobalSavedGameState.scoreWin;
        this.scoreForward = GlobalSavedGameState.scoreForward;
        this.scoreLose = GlobalSavedGameState.scoreLose;

        this.ui.setLabelScoreWinText(GlobalSavedGameState.scoreWin);
        this.ui.setLabelScoreForwardText(GlobalSavedGameState.scoreForward);
        this.ui.setLabelScoreLoseText(GlobalSavedGameState.scoreLose);

        // this.setCredits(this.credits);

        this.arrCards = [];

        this.pointsDealer = 0;
        this.pointsPlayer = 0;

        this.countCardsDealer = GI.countCardsOnStartD;
        this.countCardsPlayer = 0;

        this.arrCardsDealer = [];
        this.arrCardsPlayer = [];

        this.setLock(true, "PREPARE");

        this.dataLast = null;
        this.curState = null;

        this.isReady = false;
        this.isNewCurrency = false;
        this.isCompleteShowResult = true;

        this.setAutoPlayButtonState(GlobalSavedGameState.isAutoEnable);
        this.setSoundButtonState(GlobalSavedGameState.isSoundEnable);
    };

    terminate() {
        this.removeChildren();
        this.destroy();

        if (SETTINGS.ROOT_CONTAINERS.ui_adaptive_container)
            SETTINGS.ROOT_CONTAINERS.ui_adaptive_container.removeChildren();

        this.layerBlockInput = null;
        this.layerOverBlockInput = null;

        this.maingameBackground = null;
        this.uiBorder = null;
        this.resultWin = null;
        this.resultForward = null;
        this.resultLose = null;

        this.sndForward.stop();
        this.sndForward = null;
        this.sndLose.stop();
        this.sndLose = null;
        this.sndWin.stop();
        this.sndWin = null;

        if (this.timeoutShowResult) clearTimeout(this.timeoutShowResult);

        this.ui.terminate();
        this.ui = null;

        this.cards.terminate();
        this.cards = null;

        this.help.terminate();
        this.help = null;

        this.settings.terminate();
        this.settings = null;

        this.accountChangedWindow.terminate();
        this.accountChangedWindow = null;
    }

    onDataReady() {
        return this.isReady;
    }

    onModelChanged (data) {
        // игнорируем локальные изменения от математики(меняем из игры через this.changeModelLocal)
        if (data.local !== undefined && data.local !== null && data.local.is_local) return;

        if (!data.isLocal) {
            this.dataLast = data;
            this.isReady = true;
        }

        console.log("----------- onModelChanged ------------", data);

        if (data.account !== undefined && data.account !== null) {
            let arrBetsValue = data.account.settings.steps;
            let currency     = data.account.currency.code_name;
            let precision    = data.account.currency.minor_unit;
            let delimiter    = data.account.currency.separator;
            let minValue     = data.account.settings.min;
            let maxValue     = data.account.settings.max;

            // если ceilTo приходит, значит округлять ставки к БОЛЬШЕМУ(тем самым убираем копейки(центы))
            // round_price(1250, 0) out: 1250, round_price(1250, 1) out: 1250, round_price(1250, 100) out: 1300
            let precisionCeil = data.account.settings.ceilTo || 0;

            this.currencyBet = currency;
            this.totalBetMin = minValue;
            this.totalBetMax = maxValue;
            this.currencyPrecision = precision;
            this.currencyDelimiter = delimiter;
            this.precisionCeil = precisionCeil;

            this.ui.setBetValues(arrBetsValue, precision, delimiter, minValue, maxValue, precisionCeil);

            this.help.updateInfo(literal_price_with_check_zero_fractional_part(minValue, precision, delimiter),
                literal_price_with_check_zero_fractional_part(maxValue, precision, delimiter));
        }

        this.lastBet = this.totalBetMin;
        if (data.bet !== undefined && data.bet !== null) {
            this.lastBet            = Math.max(this.totalBetMin, data.bet.value);
            this.lastBetCurrency    = data.bet.currency.code_name;
        }

        if (data.settings !== undefined && data.settings !== null) {
            let deckInd = data.settings.deckInd;
            this.cards.setCardsSkin(deckInd);
            this.settings.setActiveDeck(deckInd);
        }

        // в игре должны быть только серверные стейты и игра должна уметь корректно переходить в любой из них в любое время по требованию сервера
        // т.е. стейт вначале очищает все и потом инициализируется для отработки своей логики(не зависит от остальных стейтов)
        let state = null;
        state = data.actions.indexOf("setAccount") > -1 ? "Init" : state;
        state = data.actions.indexOf("doStart") > -1 ? "Init" : state;
        state = data.actions.indexOf("doStop") > -1 ? "TurnPlayer" : state;
        state = data.actions.indexOf("doTake") > -1 ? "TurnDealer" : state;

        let cardsDealer = [];
        let cardsPlayer = [];

        if (data.board !== undefined &&
            data.board.dealer !== undefined && data.board.player !== undefined &&
            data.board.dealer.cards !== undefined && data.board.player.cards !== undefined) {

            cardsDealer = data.board.dealer.cards;
            cardsPlayer = data.board.player.cards;
            this.prepareDeck(cardsDealer, cardsPlayer);
        }

        if (state === "Init") {
            this.stateInit(cardsDealer, cardsPlayer, GlobalSavedGameState.isFirstRun);
            console.log("<<<<< Init");
        }
        else {
            this.ui.setModelBet(this.lastBet, false);

            // cardsDealer = data.board.dealer.cards;
            // cardsPlayer = data.board.player.cards;
            //
            // if (cardsDealer !== undefined && cardsDealer !== null &&
            //     cardsPlayer !== undefined && cardsPlayer !== null) {
            //     this.prepareDeck(cardsDealer, cardsPlayer);
            // }

            GlobalSavedGameState.isFirstRun = false;
            GlobalSavedGameState.isNeedShowResult = true;
            this.isCompleteShowResult = false;
        }

        // методы математики, вызываемые игроком по нажатию на кнопки -
        // снабжаем локальным изменением модели для мгновенного отклика(смотри changeModelLocal)

        // что бы серверные модели повторно не запускали логику, запущенную локальной моделью
        // так как TurnPlayer может постоянно повторяться, то закоментил
        // if (this.curState === state) return;

        // пришли серверные данные, но так как количество карт не изменилось,
        // то карты запущены локальной моделью до этого, поэтому только колоду подготовить
        if (this.curState !== "Init" && state !== "Init" && cardsPlayer.length === this.countCardsPlayer && cardsDealer.length === this.countCardsDealer) {
            return;
        }

        if (state === "TurnPlayer") {
            this.stateTurnPlayer(cardsDealer, cardsPlayer);
            console.log("<<<<< TurnPlayer");
        }
        if (state === "TurnDealer") {
            // если после первой раздачи не появились новые карты, значит исход произошел на очереди игрока
            if (cardsDealer.length > GI.countCardsOnStartD)
                this.stateTurnDealer(cardsDealer, cardsPlayer);
            else
                this.stateTurnPlayer(cardsDealer, cardsPlayer);
            console.log("<<<<< TurnDealer");
        }

        this.curState = state;
    }

    onAccountChanged (data) {
        // console.log("----------- onAccountChanged ------------", data);
        let credits     = data.value;
        let currency    = data.currency.code_name;
        let precision   = data.currency.minor_unit;
        let delimiter   = data.currency.separator;

        this.currencyCredits    = currency;
        this.currencyPrecision  = precision;
        this.currencyDelimiter  = delimiter;

        this.setCredits(credits);
        this.ui.setCurrency(currency);

        // что бы не запускать повторно логику первого запуска(звук тогда сбоит)
        // if (this.curState === "Init" && !GlobalSavedGameState.isFirstRun) {
        //     this.stateInit(false);
        // }

        // this.ui.setModelBet(this.ui.getTotalBet(), this.curState === "Init");
        this.ui.setAutoPlayButtonEnable(!this.ui.isLockPlaceBetButton());
    }

    onAccountSelectionChanged (data) {
        console.log("----------- onAccountSelectionChanged ------------", data);
        this.accountChangedWindow.visible = true;

        this.ui.setAutoPlayButtonState(false);
    }

    setAutoPlayButtonState (isEnabled) {
        this.ui.setAutoPlayButtonState(isEnabled);
        this.isAutoPlay = isEnabled;

        GlobalSavedGameState.isAutoEnable = isEnabled;
    }

    setSoundButtonState (isEnabled) {
        this.ui.setSoundButtonState(isEnabled);
    }

    prepareDeck (cardsDealerArg, cardsPlayerArg) {
        let self = this;

        let cardsDealer = cardsDealerArg.slice();
        let cardsPlayer = cardsPlayerArg.slice();

        this.serverCardsCountD = cardsDealer.length;

        // 4 масти по 9 карт - всего 36 карт
        //     for (let i = 0; i < 36; ++i)
        //         this.arrCards.push(i);
        const arrSuit           = ["hearts", "diamonds", "spades", "clubs"];
        const arrRank           = ["6", "7", "8", "9", "10", "J", "Q", "K", "A"];
        const countRankInSuit   = arrRank.length;

        // карты хранятся как индекс от 0 до 36
        let getCardInd = function (card) {
            const indSuit = arrSuit.indexOf(card.suit);
            const indRank = arrRank.indexOf(card.rank);
            return indSuit * countRankInSuit + indRank;
        };

        this.arrCardsDealer = [];
        this.arrCardsPlayer = [];

        for (let card of cardsPlayer) {
            this.arrCardsPlayer.push(getCardInd(card));
        }

        for (let card of cardsDealer) {
            this.arrCardsDealer.push(getCardInd(card));
        }
    }

    clearStates (isClearAll = true) {
        this.cards.clearStates();

        this.pointsDealer = 0;
        this.pointsPlayer = 0;

        this.ui.setLabelDealerPointsText("0");
        this.ui.setLabelPlayerPointsText("0");

        if (isClearAll) {
            this.countCardsDealer = GI.countCardsOnStartD;
            this.countCardsPlayer = 0;

            if (this.timeoutShowResult) clearTimeout(this.timeoutShowResult);
            this.resultWin.visible = false;
            this.resultForward.visible = false;
            this.resultLose.visible = false;
        }
    }

    stateInit(cardsDealer, cardsPlayer, isFirstRun) {
        this.setLock(true, "PREPARE");
        // if (isFirstRun)
        //     this.ui.setAutoPlayButtonEnable(false);
        let self = this;

        if (isFirstRun) {
            this.clearStates();
            this.cards.prepareNewRound(function () {
                self.ui.setModelBet(self.lastBet, true);
                self.setLock(false, "PREPARE");
                GlobalSavedGameState.isFirstRun = false;
            }, false);
        }
        else {
            this.clearStates(false);
            this.cards.placeDeck();
            if (cardsDealer.length > 0 && cardsPlayer.length > 0 && GlobalSavedGameState.isNeedShowResult) {
                let iD = 0, iP = 0;
                for (let i = 0; i < GI.countCardsOnStartAll; ++i) {
                    let isPlayer = i % 2 === 0;
                    this.cards.placeNextCard(isPlayer, isPlayer ? iP++ : iD++);
                }

                for (let i = 0; i < cardsPlayer.length - GI.countCardsOnStartP; ++i) {
                    this.cards.placeNextCard(true, iP++);
                }

                for (let i = 0; i < cardsDealer.length - GI.countCardsOnStartD; ++i) {
                    this.cards.placeNextCard(false, iD++);
                }

                if (!this.isCompleteShowResult) {
                    if (!this.checkWinCommon(true))
                        this.checkWinSpecial(true);
                }
            }

            // что бы не было повторного разлочивания по таймауту в другом стейте
            if (!this.timeoutShowResult) {
                self.ui.setModelBet(self.lastBet, true);
                this.setLock(false, "PREPARE");

                if (this.ui.getTotalBet() > this.credits || this.credits < this.totalBetMin) {
                    this.ui.setAutoPlayButtonState(false);
                }
            }
        }
    }

    stateTurnPlayer(cardsDealer, cardsPlayer) {
        let self = this;

        this.clearStates();

        this.setLock(true, "GAME");

        // первая раздача карт
        if (cardsPlayer.length === GI.countCardsOnStartP) {
            if (!GlobalSavedGameState.isFirstPlaceBet) {
                this.cards.prepareNewRound(function () {
                    self.cards.startNewRound(function () {
                        self.checkWinPlayer();
                    });
                });
                GlobalSavedGameState.isFirstPlaceBet = true;
            }
            else {
                this.cards.placeDeck();
                this.cards.startNewRound(function () {
                    self.checkWinPlayer();
                });
            }
        }
        // запрос игроком следующей карты
        else {
            GlobalSavedGameState.isFirstPlaceBet = false;

            this.cards.placeDeck();
            let iD = 0, iP = 0;
            for (let i = 0; i < GI.countCardsOnStartAll; ++i) {
                let isPlayer = i % 2 === 0;
                this.cards.placeNextCard(isPlayer, isPlayer ? iP++ : iD++);
            }

            for (let i = 0; i < cardsPlayer.length - 1 - GI.countCardsOnStartP; ++i) {
                this.cards.placeNextCard(true, iP++);
            }

            this.cards.moveNextCard(true, iP, 200, this.checkWinPlayer.bind(this));
        }

        this.countCardsPlayer = cardsPlayer.length;
    }

    stateTurnDealer(cardsDealer, cardsPlayer) {
        // check is already run from changeModelLocal
        if (this.curState === "TurnDealer") return;

        GlobalSavedGameState.isFirstPlaceBet = false;

        this.clearStates();
        this.cards.placeDeck();

        this.setLock(true, "GAME");

        let iD = 0, iP = 0;
        for (let i = 0; i < GI.countCardsOnStartAll; ++i) {
            let isPlayer = i % 2 === 0;
            this.cards.placeNextCard(isPlayer, isPlayer ? iP++ : iD++);
        }

        for (let i = 0; i < cardsPlayer.length - GI.countCardsOnStartP; ++i) {
            this.cards.placeNextCard(true, iP++);
        }

        this.countCardsPlayer = cardsPlayer.length;

        this.checkNextCard();
    }

    changeModelLocal (state) {
        // let data = {
        //     isLocal: true,
        //     actions: ["doStop"],
        //     bet: {value: this.ui.getTotalBet()},
        //     board: {
        //         dealer: {
        //             cards: [{rank: "9", suit: "clubs"}],
        //         },
        //         player: {
        //             cards: [{rank: "7", suit: "diamonds"}, {rank: "K", suit: "clubs"}],
        //         }
        //     }
        // };

        let data = this.dataLast;
        // в состянии отличном от Init - this.totalBet берется из модели
        data.bet.value = this.ui.getTotalBet();
        data.isLocal = true;

        if (state === "Start") {
            data.actions = ["doStop"];
            // данные карт не важны - важно их количество
            // так как все равно карты перевернутся только когда с сервера придет ответ
            data.board.player.cards = [{rank: "7", suit: "diamonds"}, {rank: "K", suit: "clubs"}];
            data.board.dealer.cards = [{rank: "9", suit: "clubs"}];
            this.onModelChanged(data);
        }
        if (state === "More") {
            data.actions = ["doStop"];
            // добовляем карту - что бы стейт сменился в onModelChanged
            data.board.player.cards.push({rank: "7", suit: "diamonds"});
            this.onModelChanged(data);
        }
        if (state === "Stop") {
            data.actions = ["doTake"];
            // добовляем карту - что бы стейт сменился в onModelChanged
            data.board.dealer.cards.push({rank: "7", suit: "diamonds"});
            this.onModelChanged(data);
        }
        if (state === "Take") {
            // ничего не делаем - прост запускаем таймер локальной модели localStateChange
        }
        if (state === "Test") {
            data.actions = ["doTake"];
            data.board.dealer.cards = [{rank: "9", suit: "spades"}];
            data.board.player.cards = [{rank: "A", suit: "diamonds"}, {rank: "A", suit: "spades"}];
            this.onModelChanged(data);
        }

        // запускаем таймер локальной модели
        this.space.s( 'server_action' ).next( { name : 'localStateChange' } );
        // запускаем анимацию ожидания
        window.space.s( 'pending' ).next( true );
    }

    setCredits(credits) {
        this.credits = credits;
        this.ui.setLabelCredits(credits, this.currencyPrecision, this.currencyDelimiter);
        window.parent.postMessage({isWbgMsg:true, name:'creditsChanged', credits:credits}, '*');
    }

    onButtonPlaceBet() {
        this.isReady = false;
        this.changeModelLocal("Start");
        this.space.s( 'server_action' ).next( { name : 'doStart', bet : this.ui.getTotalBet() } );
    }

    onGetCard(isPlayer, ind) {
        let card = 4;
        // TODO: demo
        {
            let arrCards = isPlayer ? this.arrCardsPlayer : this.arrCardsDealer;
            card = arrCards[ind];

            let getCardNominal = function (card) {
                return card % 9;                                // return [0..8], 9 - is count cards same suit from 6 to A
            };

            let cardPrices = [6, 7, 8, 9, 10, 2, 3, 4, 11];
            let points = cardPrices[getCardNominal(card)];

            let checkSpecialWinsComb = function (arrCards) {
                let count = 0;
                if (arrCards.length === 2 && ind === 1) {       // Комбинация АА = 21
                    for (let obj of arrCards)
                        if (getCardNominal(obj) === 8) count++;
                    if (count === 2) return true;
                }
                if (arrCards.length === 5 && ind === 4) {       // Пять картинок = 21(туз не картинка)
                    for (let obj of arrCards)
                        if (getCardNominal(obj) > 4 && getCardNominal(obj) < 8) count++;
                    if (count === 5) return true;
                }
                return false;
            };

            if (checkSpecialWinsComb(arrCards))
                isPlayer ? this.pointsPlayer = 21 : this.pointsDealer = 21;
            else
                isPlayer ? this.pointsPlayer += points : this.pointsDealer += points;

            this.ui.setLabelPlayerPointsText(this.pointsPlayer.toString());
            this.ui.setLabelDealerPointsText(this.pointsDealer.toString());
        }

        return card;
    }

    checkWinCommon(isShowResultInInit) {
        let result = null;
        if      (this.pointsPlayer === 20 && this.pointsDealer === 20)  result = "FORWARD";
        else if (this.pointsPlayer === 21 || this.pointsDealer > 21)    result = "WIN";
        else if (this.pointsPlayer > 21 || this.pointsDealer === 21)    result = "LOSE";

        if (result) {
            this.showResult(result, isShowResultInInit);

            return true;
        }

        return false;
    }

    checkWinSpecial(isShowResultInInit) {
        // TODO как считать выигрыш в этих случаях ???
        {
            console.log("<====== 5 cards OR dealer not take cards if his points >= 17 ======>");
        }

        let result = null;
        if      (this.pointsPlayer === this.pointsDealer)   result = "FORWARD";
        else if (this.pointsPlayer > this.pointsDealer)     result = "WIN";
        else if (this.pointsPlayer < this.pointsDealer)     result = "LOSE";

        if (result) {
            this.showResult(result, isShowResultInInit);
        }
    }

    showResult(strResult, isShowResultInInit = false) {
        // если в нескольких вкладках, то два раза счетчик прибавляется
        if (this.isCompleteShowResult) return;

        let self = this;

        let win = 0;
        let resultTable = null;
        switch(strResult) {
            case "WIN": {
                this.sndWin.play();
                this.scoreWin++;
                win = this.ui.getTotalBet() * 2;
                resultTable = this.resultWin;
            }
                break;
            case "FORWARD": {
                this.sndForward.play();
                this.scoreForward++;
                win = this.ui.getTotalBet() * 0.9;
                resultTable = this.resultForward;
            }
                break;
            case "LOSE": {
                this.sndLose.play();
                this.scoreLose++;
                resultTable = this.resultLose;
            }
                break;
            default: break;
        }

        GlobalSavedGameState.scoreWin = this.scoreWin;
        GlobalSavedGameState.scoreForward = this.scoreForward;
        GlobalSavedGameState.scoreLose = this.scoreLose;

        this.ui.setLabelScoreWinText(this.scoreWin.toString());
        this.ui.setLabelScoreForwardText(this.scoreForward.toString());
        this.ui.setLabelScoreLoseText(this.scoreLose.toString());

        // this.credits += win;
        // this.setCredits(this.credits);

        window.parent.postMessage({isWbgMsg:true, name:'showResult', strResult:strResult, win:win}, '*');

        this.setLock(true, "PREPARE");

        if (!isShowResultInInit) {
            this.changeModelLocal("Take");
            this.space.s('server_action').next({name: 'doTake'});
        }

        resultTable.visible = true;
        this.timeoutShowResult = setTimeout(function() {
            resultTable.visible = false;
            window.parent.postMessage({isWbgMsg:true, name:'hideResult'}, '*');
            if (self.curState === "Init") {
                self.ui.setModelBet(self.ui.getTotalBet(), true);
                self.setLock(false, "PREPARE");

                if (self.ui.getTotalBet() > self.credits || self.credits < self.totalBetMin) {
                    self.ui.setAutoPlayButtonState(false);
                }
            }
            self.timeoutShowResult = null;
        }, 2000);

        this.isCompleteShowResult = true;
    }

    checkWinPlayer() {
        if (!this.checkWinCommon()) {
            if (this.countCardsPlayer >= GMaxCountCards) {
                this.onButtonStop();
            }
            else
                this.setLock(false, "GAME");
        }
    }

    onButtonMore() {
        if (this.countCardsPlayer < GMaxCountCards) {
            this.isReady = false;
            this.changeModelLocal("More");
            this.space.s( 'server_action' ).next( { name : 'doMore' } );

            this.setLock(true, "GAME");
        }
    }

    onButtonStop() {
        this.isReady = false;
        if (this.pointsDealer < GDealerMaxPointsForStopTake) {
            this.changeModelLocal("Stop");
        }
        this.space.s( 'server_action' ).next( { name : 'doStop' } );

        this.setLock(true, "GAME");
    }

    checkNextCard() {
        if (this.countCardsDealer < this.serverCardsCountD) {
            this.cards.moveNextCard(false, this.countCardsDealer++, 200, this.checkNextCard.bind( this ) );
        }
        else {
            if (!this.checkWinCommon())
                this.checkWinSpecial();
        }
    };

    onButtonHelp() {
        this.help.visible = !this.help.visible;
        window.parent.postMessage({isWbgMsg:true, name:'showHelp'}, '*');
    }

    onButtonSkin() {
        this.settings.visible = !this.settings.visible;
        this.settings.resetActiveDeck();
    }

    onButtonSkinApply(deckInd) {
        this.settings.visible = !this.settings.visible;
        this.cards.setCardsSkin(deckInd);
        this.space.s( 'server_action' ).next( { name : 'doSetSettings', param : {deckInd: deckInd}} )
    }

    onButtonAutoOff() {
        this.isAutoPlay = false;
        GlobalSavedGameState.isAutoEnable = this.isAutoPlay;
    }

    onButtonAutoOn() {
        this.isAutoPlay = true;
        GlobalSavedGameState.isAutoEnable = this.isAutoPlay;
        this.tryAutoStartRound();
        this.tryAutoNextStep();
    }

    onButtonExit() {
        // this.space.s( 'goLobby' ).next();
        goLobby();
    }

    setLock(isLock, state) {
        this.ui.setLock(isLock, state);
        if (!isLock) {
            this.tryAutoStartRound();
            this.tryAutoNextStep();
        }
    }

    tryAutoStartRound(){
        if (this.isAutoPlay){
            if (!this.ui.isLockPlaceBetButton()) {
                this.onButtonPlaceBet();
            }
        }
    }

    tryAutoNextStep(){
        if (this.isAutoPlay){
            if (!this.ui.isLockMoreButton()) {
                if (this.pointsDealer >= GDealerMaxPointsForStopTake && this.pointsPlayer < this.pointsDealer) {
                    this.onButtonMore();
                }
                else if (this.pointsPlayer < GDealerMaxPointsForStopTake - 2){
                    this.onButtonMore();
                }
                else {
                    this.onButtonStop();
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/mainscene.es6